import React, { Component } from 'react';
import firebase from '../../Firebase';
import Swal from 'sweetalert2';

class AdministratorLogin extends Component {
    constructor() {
        super();
        this.db = firebase.firestore().collection('administrators');
        this.unsubscribe = null;
        this.state = {
            nik: "",
            password: "",
            isLoading: false
        }
    }

    componentDidMount() {
        this.getCurrentDate();
        this.cekLogin();
    }

    kasihNol = (data) => {
        if(data < 10)
        {
            return '0'+data;
        }else{
            return data;
        }
    }

    date = () => {
        const hmm = this;
        const today = new Date();
        const time = hmm.kasihNol(today.getHours()) + ":" + hmm.kasihNol(today.getMinutes()) + ":" + hmm.kasihNol(today.getSeconds());
        const date = hmm.kasihNol(today.getDate())+'/'+hmm.kasihNol((today.getMonth()+1))+'/'+hmm.kasihNol(today.getFullYear());
        hmm.setState({
            date: date,
            time: time
        });
    }

    getCurrentDate = () => {
        const hmm = this;
        hmm.date();
        setInterval(function () {
            hmm.date();
        }, 1000);
    }

    doSubmit = (e) => {
        e.preventDefault();
        this.setState({
            isLoading: true
        });
        console.log('nik '+this.state.nik);
        console.log('password '+this.state.password);
        try {
            firebase.firestore()
            .collection('administrators')
            .where('username', '==', this.state.nik)
            .where('password', '==', this.state.password)
            .get()
            .then(querySnapshoot => {
                this.setState({
                    isLoading : false
                });

                if(querySnapshoot.docs.length > 0) {
                    // Berarti data nya ada
                    Swal.fire({
                        title: 'Login Berhasil !',
                        text: 'Data ditemukan, login berhasil',
                        icon: 'success',
                        showCancelButton: false, 
                        confirmButtonText: 'Oke'
                    }).then((result) => {
                        // this.props.history.push('/form');
                        // window.location.reload();
                        localStorage.setItem('login', JSON.stringify(querySnapshoot.docs.map(doc => doc.data())));
                        window.location.href = '/administrator';
                    });
                }else{
                    // Berarti data nya ga ada
                    Swal.fire({
                        title: 'Login Gagal !',
                        text: 'Mohon maaf. Data kamu tidak ditemukan di system',
                        icon: 'error',
                        showCancelButton: false, 
                        confirmButtonText: 'Oke'
                    }).then((result) => {
                        window.location.reload();
                    });
                }
            })
        } catch( e ) {
            console.log( e );
        }
    }

    onChange = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    cekLogin = () => {
        const id = localStorage.getItem('login');
        if(id !=  null) {
            // Ini sudah login, masuk ke form
            this.props.history.push('/administrator');
        }
    }

    render() {
        return(
            <div className="">
                <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
                    <div className="container-fluid">
                        <div className="navbar-wrapper" style={{ width: "100%" }}>
                            <div className="navbar-container">
                                <div className="navbar-collapse" id="navbar-mobile">
                                    <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                                        <div className="navbar-header">
                                            <ul className="nav navbar-nav flex-row">
                                                <li className="nav-item mr-auto">
                                                    <a className="navbar-brand" href="/">
                                                        <div className="brand-logo">
                                                            <img alt="Logo" className="logo" src={ require('../../assets/logos/logo-pas.jpg') } />
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                                        <div className="navbar-header">
                                            <ul className="nav navbar-nav flex-column">
                                                <li className="nav-item text-center"><h1 className="font-header">PT. PRAKARSA ALAM SEGAR</h1></li>
                                                <li className="nav-item text-center"><h2 className="font-sub-header">Human Resource Department</h2></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="bookmark-wrapper d-flex align-items-center time-container">
                                        <div className="navbar-header">
                                            <ul className="nav navbar-nav flex-column">
                                                <li className="nav-item text-right"><span className="font-date">{this.state.date}</span></li>
                                                <li className="nav-item text-right"><span className="font-time">{this.state.time}</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                <div className="pembatas"></div>
                <div className="app-content content" style={{ margin: "0" }}>
                    <div className="content-overlay"></div>
                    <div className="content-wrapper mb-2">
                        <div className="content-header row">
                        </div>
                        <div className="content-body">
                            <section id="auth-login" className="row flexbox-container">
                                <div className="col-md-4 col-11" style={{ margin: "0 auto" }}>
                                    <div className="card bg-authentication mb-0">
                                        <div className="row m-0">
                                            <div className="col-md-12 col-12 px-0">
                                                <div className="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
                                                    <div className="card-header pb-1">
                                                        <div className="card-title">
                                                            <h4 className="text-center mb-0">Halaman Login Administrator</h4>
                                                        </div>
                                                    </div>
                                                    <div className="card-content">
                                                        <div className="card-body">
                                                            <div className="divider">
                                                                <div className="divider-text text-uppercase text-muted"><small>Login dengan nik bagian belakang & password</small>
                                                                </div>
                                                            </div>
                                                            <form onSubmit={this.doSubmit}>
                                                                <div className="form-group mb-50">
                                                                    <label className="text-bold-600" htmlFor="nik">NIK</label>
                                                                    <input required onChange={this.onChange} value={this.state.nik} name="nik" type="text" className="form-control" id="nik" placeholder="Contoh : 12546" /></div>
                                                                <div className="form-group">
                                                                    <label className="text-bold-600" htmlFor="password">Password</label>
                                                                    <input required onChange={this.onChange} value={this.state.password} name="password" type="password" className="form-control" id="password" />
                                                                </div>
                                                                <button disabled={this.state.isLoading} type="submit" className="btn login-button glow w-100 position-relative text-white">
                                                                    {
                                                                        this.state.isLoading === true ? <span className="text-white"><i className="bx bx-spin bx-loader"></i> Memeriksa..</span> : <span>Login<i id="icon-arrow" className="bx bx-right-arrow-alt"></i></span>
                                                                    }
                                                                </button>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdministratorLogin;
